// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3feGE","inputDescription":"styles_inputDescription__QNF7K"};